import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { SubscriptionDTO } from '@app/core/services/subscription/models/subscription/subscription.model';

@Component({
    selector: 'ap-subscription-holder-payer-panel',
    templateUrl: './subscription-holder-payer-panel.component.html',
    styleUrl: './subscription-holder-payer-panel.component.css',
    standalone: false
})
export class SubscriptionHolderPayerPanelComponent {
  @Input() subscription: SubscriptionDTO;
  @Input() userView = false;
  @Input() isPayer = false;

  Permissions = PermissionEnum;

  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  navigateToUser(mobilityAccountId: number) {
    this.router.navigate(['/users', mobilityAccountId, 'all']);
  }

  showHolderInfos() {
    return !this.userView || (this.isPayer && this.subscription.subscriptionPayer);
  }

  showPayerInfos() {
    return this.subscription.subscriptionPayer && (!this.userView || !this.isPayer);
  }

  showHolderPaymentsInfos() {
    const hasPayer = !!this.subscription.subscriptionPayer;
    if (!this.userView) {
      return !hasPayer;
    }
    return !hasPayer && this.isPayer;
  }

  showPayerPaymentsInfos() {
    return !!this.subscription.subscriptionPayer;
  }

  showPayerPaymentsInfosInFirstRow() {
    return this.showHolderInfos() && !this.showPayerInfos() && !this.showHolderPaymentsInfos() && this.showPayerPaymentsInfos();
  }
}
